import React from 'react'
import { Link} from 'react-router-dom'
import { useState, useEffect } from 'react';
import titlesData from '../titles.json';


function Header(userData) {
   
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
    const toggleLanguage = () => {
        const newLanguage = language === 'en' ? 'hi' : 'en';
        setLanguage(newLanguage);
        localStorage.setItem("language", newLanguage);
        window.location.reload();
    };

    

  return (
    //  Topbar Open
    <>
        <div className="container-fluid py-0 header">
        <div className="px-3">
            <div className="row d-flex align-items-center">
                <div className="col-lg-6 col-md-6">
                    <div className="logo_content">
                        <Link to="/dashboard" className="navbar-brand">
                            <img src="assets/images/logo.png" className="brand-logo" alt="UPDES"/>
                        </Link>
                        <div className="text d-flex align-items-center">
                            {language === 'hi' ? (
                                <h3 className="mb-0 innerbrand-name" dangerouslySetInnerHTML={{ __html: titlesData.hi.LogoText }}></h3>
                            ) : (
                                <h3 className="mb-0 innerbrand-name" dangerouslySetInnerHTML={{ __html: titlesData.en.LogoText }}></h3>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 ">
                    <ul className="header-right-text">
                        <li><img src="assets/images/user.svg"/> Login User: <span>{userData.LoginUser}  &nbsp; |</span></li>
                        <li><img src="assets/images/user.svg"/> User Level: <span> {userData.UserLevel} &nbsp;</span></li>
                        {/* <li><a href="#" onClick={toggleLanguage} className="language">
                        <img src="assets/images/flag.svg"/> 

                        {language === 'en' ? <span className="pe-2 ps-1">हिन्दी वेबसाइट</span> : <span className="pe-2 ps-1">English Website</span>}    


                         
                        </a>
                        </li> */}
                    </ul>
                </div>
          
            </div>
        </div>
    </div>

    </>
  )
}

export default Header